import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Parsemj from '@/components/Parsemj'
import Parsemh from '@/components/Parsemh'
import Parsemhn from '@/components/Parsemhn'
import ParsemhAt from '@/components/ParsemhAt'
import ParseShc from '@/components/ParseShc'
import ListMjSpo from '@/components/ListMjSpo'
import ListShcSpo from '@/components/ListShcSpo'
import ListMhn from '@/components/ListMhn'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: HelloWorld
    },
    {
      path: '/parsemj',
      name: 'parsemj',
      component: Parsemj
    },
    {
      path: '/parsemh',
      name: 'parsemh',
      component: Parsemh
    },
    {
      path: '/parsemhn',
      name: 'parsemhn',
      component: Parsemhn
    },
    {
      path: '/parsemhat',
      name: 'parsemhat',
      component: ParsemhAt
    },
    {
      path: '/listmjspo',
      name: 'listmjspo',
      component: ListMjSpo
    },
    {
      path: '/listmhn',
      name: 'listmhn',
      component: ListMhn
    },
    {
      path: '/listshcspo',
      name: 'listshcspo',
      component: ListShcSpo
    },
    {
      path: '/parseshc',
      name: 'parseshc',
      component: ParseShc
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js